import { GenericBlankState, Pane } from "components/ui"
import { Box, StackView, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"
import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import SelectionAttendees from "./SelectionAttendees"

const Attendees = () => {
  const { registerable } = useContext(RegisterableContext)
  const { attendeeTypeSelections } = registerable

  const selectionsWithCount = attendeeTypeSelections.filter(({ count }) => count > 0)
  const selections = selectionsWithCount.reduce((result, selection) => {
    const group = selection.waitlist ? "waitlisted" : "normal"
    result[group] = result[group] || []
    result[group].push(selection)
    return result
  }, {})

  return (
    <Pane marginBottom={2}>
      <Pane.Header>
        <Pane.Title>Attendees</Pane.Title>
      </Pane.Header>
      <Pane.Body axis="vertical" gap={4}>
        {selectionsWithCount.length > 0 ? (
          <>
            {selections.normal && (
              <StackView gap={2}>
                {selections.normal.map(selection => (
                  <SelectionAttendees
                    key={selection.id}
                    id={selection.id}
                    waitlist={selection.waitlist}
                  />
                ))}
              </StackView>
            )}
            {selections.waitlisted && (
              <Box
                padding={2}
                margin={-2}
                backgroundColor={colors.neutral_080}
                borderRadius="0 0 3px 3px"
              >
                <Text marginBottom={2} size={3} weight={600} color={colors.neutral_010}>
                  Waitlist
                </Text>

                <StackView gap={2}>
                  {selections.waitlisted.map(selection => (
                    <SelectionAttendees
                      key={selection.id}
                      id={selection.id}
                      waitlist={selection.waitlist}
                    />
                  ))}
                </StackView>
              </Box>
            )}
          </>
        ) : (
          <GenericBlankState message="To get started, make selections above" />
        )}
      </Pane.Body>
    </Pane>
  )
}

export default Attendees
